import { setupEntryPoint } from './setupEntryPoint';
import App from '@/layouts/website/MainLayout.vue';
import router from '@/routers/website';

setupEntryPoint(App, router);
